<template>

  <article class="panels__side panels__side--left">
    <div class="panels__side panels__side--inner panels__side--form">
      <div class="form form--avatar">
        <div class="form-material md-layout md-gutter">
          <div class="md-layout-item">


            <h4 class="h4" v-show="!showPreview">{{ $t('avatar.photo.title') }}</h4>
            <h4 class="h4" v-show="showPreview">{{ $t('avatar.photo.titleUploaded') }}</h4>

            <div class="content">

              <div class="form--avatar__upload">
                <div class="select-text">{{ $t('avatar.photo.select') }}</div>
                <div>
                <strong>{{ $t('avatar.photo.recommend') }}</strong>
                  <ul class="recommendation-list">
                    <li>
                      {{ $t('avatar.photo.size') }}
                    </li>
                    <li>
                      {{ $t('avatar.photo.adjust') }}
                    </li>
                  </ul>
                </div>
                <div class="form--avatar__upload-container">
                  <div :class="'form--avatar__upload-input ' + [(!/^#/.test(color) && showPreview)? color : '']">
                    <div @click="triggerInputFile">
                      <div v-show="!showPreview" class="form--avatar__upload-input-label">{{ $t('avatar.photo.upload') }}</div>
                      <div v-show="!showPreview" class="form--avatar__upload-input-plus">+</div>
                    </div>

                    <input type="file" id="file" ref="file" accept=".jpg,.jpeg,.png,.gif,.bmp" v-on:change="handleFileUpload()"/>

                    <div :style="{left: dragLeft, top: dragTop}" class="form--avatar__upload-img" v-show="showPreview" v-dragged="onDragged">
                      <img :style="{transform: `scale(${scalePreview})`}" :src="imagePreview" />
                    </div>

                  </div>

                  <div v-if="/^#/.test(color)" class="form--avatar__upload-border" :style="{borderColor: (showPreview) ? color : 'transparent'}" />
                  <div v-else-if="!/^#/.test(color)" :class="[(!/^#/.test(color) && showPreview)? 'form--avatar__upload-border-rainbow' : '']">


                  </div>
                </div>

                <div v-show="showPreview" @click="triggerInputFile" class="form--avatar__upload-update">
                  <span class="button">{{ $t('avatar.photo.change') }}</span>
                </div>

                <div v-show="showPreview" class="range-container">
                  <div class="range-container__control range-container__control--minus" @click="clickRange(- sliderStep)">
                    -
                    <span class="range-container__control__info">{{ $t('avatar.photo.zoomOut') }}</span>
                  </div>
                  <range-slider
                    class="slider"
                    :min="sliderMin"
                    :max="sliderMax"
                    :step="sliderStep"
                    v-on:change="changeSliderEnd"
                    v-model="sliderValue">
                  </range-slider>
                  <div class="range-container__control range-container__control" @click="clickRange(sliderStep)">
                    +
                    <span class="range-container__control__info">{{ $t('avatar.photo.zoomIn') }}</span>
                  </div>
                </div>

                <div class="color--ring-container">
                  <h4 class="h4">{{ $t('avatar.color.title') }}</h4>
                  <div>{{ $t('avatar.color.select') }}</div>
                  <ColorRing @change="clickColor" :list="['#fe414e', '#b4b4b4', '#000', 'rainbow']"/>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="panels__side panels__side--inner panels__side--form">
        <div class="form form--avatar">
          <div class="form-material md-layout md-gutter">
            <div class="md-layout-item">

            <h4 class="h4">{{ $t('avatar.review.title') }}</h4>
            <canvas ref="canvas" height="400" width="400"></canvas>


              <div class="instructions">
                <div class="instructions-tabs">
                  <md-tabs class="md-transparent" @md-changed="clickTab">
                    <md-tab id="instruction-tab-0" v-bind:md-label="$t('avatar.instructions.title_vox')"></md-tab>
                    <md-tab id="instruction-tab-1" v-bind:md-label="$t('avatar.instructions.title_outlook_mac')"></md-tab>
                    <md-tab id="instruction-tab-2" v-bind:md-label="$t('avatar.instructions.title_outlook_windows')"></md-tab>
                    <md-tab id="instruction-tab-3" v-bind:md-label="$t('avatar.instructions.title_outlook_webmail')"></md-tab>
                    <md-tab id="instruction-tab-4" v-bind:md-label="$t('avatar.instructions.title_linkedin')"></md-tab>
                  </md-tabs>


                  <div class="md-content md-tabs-content md-theme-default">
                    <div class="md-tabs-container">
                      <div class="md-tab md-tab-margin" :style="{marginLeft: tabsSlide + '%' }">
                        <div class="instructions-tabs__item">
                          <div v-html="$t('avatar.instructions.vox')"></div>
                        </div>
                        <a :href="download" v-bind:class="{ inactive: !download }" class="button" download="avatar_vox">{{ $t('avatar.review.download') }}</a>
                      </div>

                      <div class="md-tab">
                        <div class="instructions-tabs__item">
                          <div v-html="$t('avatar.instructions.outlook_mac')"></div>
                        </div>
                        <a :href="downloadBg" v-bind:class="{ inactive: !downloadBg }" class="button" download="avatar_outlook_mac">{{ $t('avatar.review.download') }}</a>
                      </div>

                      <div class="md-tab">
                        <div class="instructions-tabs__item">
                          <div v-html="$t('avatar.instructions.outlook_windows')"></div>
                        </div>
                        <a :href="downloadBg" v-bind:class="{ inactive: !downloadBg }" class="button" download="avatar_outlook_windows">{{ $t('avatar.review.download') }}</a>
                      </div>

                      <div class="md-tab">
                        <div class="instructions-tabs__item">
                          <div v-html="$t('avatar.instructions.outlook_webmail')"></div>
                      </div>
                        <a :href="downloadBg" v-bind:class="{ inactive: !downloadBg }" class="button" download="avatar_outlook_webmail">{{ $t('avatar.review.download') }}</a>
                      </div>

                      <div class="md-tab">
                        <div class="instructions-tabs__item">
                          <div v-html="$t('avatar.instructions.linkedin')"></div>
                      </div>
                        <a :href="downloadBigStroke" v-bind:class="{ inactive: !downloadBigStroke }" class="button" download="avatar_linkedin">{{ $t('avatar.review.download') }}</a>
                      </div>
                    </div>
                  </div>

                </div>

              </div>


          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import RangeSlider from 'vue-range-slider';

import 'vue-material/dist/vue-material.min.css';

import ColorRing from './ColorRing';

import EventBus from '../eventBus';
import Utils from '../utils';

export default {
  name: 'FormAvatar',
  data: function data() {
    return {
      color: '#000',

      tabsSlide: 0,

      download: null,
      downloadBg: null,
      downloadBgWide: null,
      downloadBigStroke: null,

      sliderValue: 50,
      sliderMin: 1,
      sliderMax: 101,
      sliderStep: 1,


      file: '',
      showPreview: false,
      imagePreview: '',

      dragged: false,
      dragLeft: 0,
      dragTop: 0,
      dragLeftInt: 0,
      dragTopInt: 0,

      canvas: null,
      ctx: null,
    }
  },
  components: {
    ColorRing,
    RangeSlider
  },
  watch: {

  },
  computed: {
    scalePreview: function () {
      return this.sliderValue / 50;
    },
  },
  mounted: function () {
    var canvas = this.$refs.canvas;
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
  },
  methods: {
    changeSliderEnd (value) {
      this.drawCanvasImage();
    },
    clickTab(value) {
      if(value) {
        let index = parseInt(value.replace('instruction-tab-', ''), 10);
        this.tabsSlide = - index * 100;
      }
    },
    clickRange(value) {
      let newValue = value + this.sliderValue
      if ((newValue <= this.sliderMax) && (newValue >= this.sliderMin)) {
        this.sliderValue = newValue;
        this.drawCanvasImage();
      }
    },
    clickColor (value) {
      this.color = value;
      this.drawCanvasImage();
    },
    triggerInputFile () {
    	this.$refs.file.click();
    },
    onDragged({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
      if (first) {
        this.dragged = true;
        return;
      }
      if (last) {
        this.drawCanvasImage();
        this.dragged = false;
        return;
      }
      var l = +window.getComputedStyle(el)['left'].slice(0, -2) || 0
      var t = +window.getComputedStyle(el)['top'].slice(0, -2) || 0

      this.dragLeftInt = l + deltaX
      this.dragTopInt = t + deltaY

      this.dragLeft = this.dragLeftInt + 'px'
      this.dragTop = this.dragTopInt + 'px'
    },

    submitFile(){
      //let formData = new FormData();
      //formData.append('file', this.file);
    },
    handleFileUpload() {
      this.sliderValue = 50;
      this.dragLeft = '0px';
      this.dragTop = '0px';
      this.file = this.$refs.file.files[0];
      let reader  = new FileReader();

      reader.addEventListener("load", function () {
        this.showPreview = true;
        this.imagePreview = reader.result;

        this.drawCanvasImage();

      }.bind(this), false);


      if(this.file){
        if ( /\.(jpe?g|png|bmp|gif)$/i.test( this.file.name ) ) {
          reader.readAsDataURL( this.file );
        }
      }
    },
    drawCanvasImageCommon(image, strokeWidth) {

      let defaultPreviewSize = 210;
      let ratioPreview = defaultPreviewSize / this.canvas.width;

      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      // this.ctx.arc(this.canvas.height / 2, this.canvas.height / 2, 95, 0, Math.PI*2, false);
      this.ctx.arc(this.canvas.height / 2, this.canvas.height / 2, (this.canvas.height / 2) - strokeWidth, 0, Math.PI*2, false);
      this.ctx.fillStyle = '#fff';
      this.ctx.fill();

      this.ctx.globalCompositeOperation = 'source-atop';
      this.ctx.drawImage(
        image,
        this.dragLeftInt / ratioPreview, this.dragTopInt / ratioPreview,
        (image.width * this.scalePreview) / ratioPreview, (image.height * this.scalePreview) / ratioPreview
      );
      this.ctx.globalCompositeOperation = 'source-over';

      this.ctx.beginPath();
      //this.ctx.arc(105, 105, 95, 0, Math.PI*2, false);
      this.ctx.arc(this.canvas.height / 2, this.canvas.height / 2, (this.canvas.height / 2) - strokeWidth, 0, Math.PI*2, false);
      this.ctx.closePath();
      if (!/^#/.test(this.color)){
        var gr = this.ctx.createLinearGradient(70,70,330,330);
        gr.addColorStop(0, '#fa000f');
        gr.addColorStop(1/10, '#fa000f');
        gr.addColorStop(1/10 , '#ffa826');
        gr.addColorStop(2/10 , '#ffa826');
        gr.addColorStop(2/10 , '#f0ea41');
        gr.addColorStop(3/10, '#f0ea41');
        gr.addColorStop(3/10, '#00c15e');
        gr.addColorStop(4/10, '#00c15e');
        gr.addColorStop(4/10, '#385ffa');
        gr.addColorStop(5/10 , '#385ffa');
        gr.addColorStop(5/10, '#8e00e4');
        gr.addColorStop(6/10, '#8e00e4');
        gr.addColorStop(6/10, '#000000');
        gr.addColorStop(7/10 , '#000000');
        gr.addColorStop(7/10, '#774f36');
        gr.addColorStop(8/10, '#774f36');
        gr.addColorStop(8/10, '#16c7d6');
        gr.addColorStop(9/10, '#16c7d6');
        gr.addColorStop(9/10, '#f787e6');
        gr.addColorStop(10/10, '#f787e6');
        this.ctx.strokeStyle = gr;
      } else {
        this.ctx.strokeStyle = this.color;
      }
      this.ctx.lineWidth = strokeWidth;
      this.ctx.stroke();
    },
    drawCanvasImage() {
      // this.canvas.height = 210;
      // this.canvas.width = 210;

      this.canvas.height = 400;
      this.canvas.width = 400;

      let strokeWidth = 20;

      var image = new Image();

      image.onload = () => {

        this.drawCanvasImageCommon(image, strokeWidth);

        if (this.imagePreview) {
          this.download = this.canvas.toDataURL('image/png');
        }

        strokeWidth = 30;
        this.drawCanvasImageCommon(image, strokeWidth);

        if (this.imagePreview) {
          this.downloadBigStroke = this.canvas.toDataURL('image/png');
        }

        // add white bg
        strokeWidth = 20;
        this.drawCanvasImageCommon(image, strokeWidth);
        this.ctx.globalCompositeOperation = 'destination-over';
        this.ctx.fillStyle = '#fff';
        // this.ctx.fillStyle = 'rgba(255, 255, 255, 0)';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

        if (this.imagePreview) {
          this.downloadBg = this.canvas.toDataURL('image/png');
        }

        /*
        if (this.imagePreview) {
          this.download2 = this.canvas.toDataURL('image/png');
        }
        // change size
        // this.changeCanvasSize(this.download2);
        */

      };
      image.src = this.imagePreview;
    },
    changeCanvasSize (canvasResult) {
        this.canvas.height = 210;
        this.canvas.width = 280;

        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        var img = new Image();
        img.onload = () => {
          this.ctx.drawImage(img, 35, 0);

          this.ctx.globalCompositeOperation = 'destination-over';
          // this.ctx.fillStyle = '#fff';
          this.ctx.fillStyle = 'rgba(255, 255, 255, 0)';
          this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

          if (this.imagePreview) {
            this.downloadBgWide = this.canvas.toDataURL('image/png');
          }
        };
        img.src = canvasResult;
    }

  }
}

</script>



// WEBPACK FOOTER //
// src/components/FormAvatar.vue